import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from "@angular/core";
import { OfiButton } from "@shared/components/ofi-button-group/ofi-button";

@Component({
    selector: "ofi-button-group",
    templateUrl: "./ofi-button-group.component.html",
    styleUrls: ["./ofi-button-group.component.scss"],
    standalone: false
})
export class OfiButtonGroupComponent implements OnInit, OnChanges {
  @Input()
  public buttons: OfiButton[] = [];

  @Input()
  public value: string | number;

  @Output()
  public valueChange = new EventEmitter<string | number>();

  constructor() {}

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes.hasOwnProperty("value")) {
      this._processButtons();
    }
    if (changes.hasOwnProperty("buttons")) {
      this._processButtons();
    }
  }

  public ngOnInit(): void {}

  public onClick(btn: OfiButton): void {
    this.valueChange.emit(btn.value);
    this.value = btn.value;
    this._processButtons();
  }

  private _processButtons(): void {
    const buttons: OfiButton[] = [];

    for (const button of this.buttons) {
      let cssClass = button.cssClass || ["e-btn", "ofi-secondary-action"];
      cssClass = Array.isArray(cssClass) ? [...cssClass] : cssClass.split(" ");

      if (this.value === button.value) {
        if (!cssClass.find((c) => c === "selected")) {
          cssClass.push("selected");
        }
      } else {
        cssClass = [...cssClass].filter((c) => c !== "selected");
      }

      buttons.push({
        ...button,
        cssClass: cssClass.join(" "),
      });
    }

    this.buttons = buttons;
  }
}
